"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IERC20Metadata__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var IERC20Metadata__factory_1 = require("./IERC20Metadata__factory");
Object.defineProperty(exports, "IERC20Metadata__factory", { enumerable: true, get: function () { return IERC20Metadata__factory_1.IERC20Metadata__factory; } });
